/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Incident_DescriptionInputs */



/**
* | output |
* | --- |
* | "Investigation of incidents and accidents on behalf of owners, charterers and managers." |
*
* @param {Service_Incident_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_incident_description = /** @type {((inputs?: Service_Incident_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Incident_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("代表船东、租家和管理公司调查事件和事故。")
	return /** @type {LocalizedString} */ ("Investigation of incidents and accidents on behalf of owners, charterers and managers.")
});